import React from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from 'react-redux';
import cardReader from '../../../../images/Card_Reader.gif';
import qrCode from '../../../../images/Qr_Code.gif';
import { IKIOSKModel, IkioskMenuIds, IKioskOtherServiceMenu, KioskMessage, EkioskConfigMessageKeys } from "../../../../models/kioskModel2";
import { menuTypeAction } from "../../../../store/actions";
import moment from "moment";
import { Modal, ModalBody } from 'reactstrap';
import errorimg from '../../../../images/error.png';
import { Ilanguages } from "../../../../models/utilitiesModel";

const LoginMenus: React.FC = () => {
    const dispatch = useDispatch();
    const { t } = useTranslation("translations");
    const authenticationTypes: IKioskOtherServiceMenu[] = useSelector((state: any) => (state?.kioskReducer2 as IKIOSKModel)?.logInMenus || []);
    const kioskStartTime = useSelector((state: any) => (state.kioskReducer2 as IKIOSKModel)?.kioskStartTime || "");
    const kioskEndTime = useSelector((state: any) => (state.kioskReducer2 as IKIOSKModel)?.kioskEndTime || "");
    const dateTime = useSelector((state: any) => (state.kioskReducer2 as IKIOSKModel)?.currentDateAndTime || new Date());
    const startMoment = moment(kioskStartTime, "HH:mm");
    const endMoment = moment(kioskEndTime, "HH:mm");
    const currentMoment = moment(dateTime);

    const isStartTimeExceeded = currentMoment.isSameOrAfter(startMoment, 'minute');  
    const isEndTimeExceeded = currentMoment.isSameOrAfter(endMoment, 'minute');     
    const startTimeExceed = currentMoment.isBefore(startMoment, 'minute');     

    const kioskNonworkingMesssage: KioskMessage = useSelector((state: any) => (state?.kioskReducer2 as IKIOSKModel)?.kioskConfigdata?.kioskMessage?.find((x) => x?.msgKey === EkioskConfigMessageKeys.KIOSKNONWORKINGMES) || undefined);
    const language: any = useSelector((state) => (state?.kioskReducer2 as IKIOSKModel)?.language || Ilanguages.ENG);
    console.log('isStartTimeExceeded', { t,isEndTimeExceeded, kioskStartTime, kioskEndTime, dateTime, isStartTimeExceeded, a: moment(dateTime).format('HH'), language,authenticationTypes })

    const getImagesBymenu = (menuCode) => {
        let imgSrc;
        switch (menuCode) {
            case IkioskMenuIds.INSERTEMIRATESID:
                imgSrc = cardReader;
                break;
            case IkioskMenuIds.SCANQR:
                imgSrc = qrCode;
                break;
            default:
                break;
        }
        return imgSrc;
    }
    return (
        <div className='Kiosk_input'>
            <div className='text-center'>
                {(kioskStartTime && kioskEndTime) && ((isStartTimeExceeded && isEndTimeExceeded) || (startTimeExceed)) &&
                    <>
                        <Modal isOpen={true} className="kiosk_error_modal">
                            <ModalBody>
                                <div className="errorMessage">
                                    <img src={errorimg} alt="" />
                                    <p>{kioskNonworkingMesssage ?
                                        (language === Ilanguages.ENG ? kioskNonworkingMesssage?.msgValueEn : kioskNonworkingMesssage.msgValueAr).replace('{starttime}', kioskStartTime ? kioskStartTime: 'N/A').replace('{endtime}', kioskEndTime ? kioskEndTime : 'N/A')
                                        : t('kiosktranslation.timeExpiryMsg').replace('{starttime}', kioskStartTime ? kioskStartTime : 'N/A').replace('{endtime}', kioskEndTime ? kioskEndTime : 'N/A')}
                                    </p>
                                </div>
                            </ModalBody>
                        </Modal>
                    </>}
                <h2>{t("kiosktranslation.welcometodubai-Ar")}</h2>
                <h2>{t("kiosktranslation.welcometodubai")}</h2>
                <div style={{marginTop: "60px"}}>
                    <h6>{t("kiosktranslation.proceedsteps")}</h6>
                    <h6>{t("kiosktranslation.proceedsteps-Ar")}</h6>
                </div>
            </div>
            {authenticationTypes?.map((menu, index) => (
                <div key={index} className='d-flex flex-column align-items-start gap-2' onClick={() => { dispatch(menuTypeAction(menu.branchTypeCode)) }}>
                    {index < 2 ?
                        <div className='d-flex align-items-center gap-3 pointer'>
                            <div className='input_card'>
                            <img src={getImagesBymenu(menu.branchTypeCode)} alt="Card Reader" width="135" height="171" />
                            <div className='d-flex flex-column justify-content-center'>
                                <span>{menu?.branchNameEn}</span>
                                <span>{menu?.branchNameAr}</span>
                            </div>
                            </div>
                        </div>
                        :
                        <div className='d-flex flex-column gap-3 pointer' style={{minWidth:'358px'}}>
                            <div className='input_card'>
                                <i className={menu.branchTypeCode === IkioskMenuIds.INPUTMOBILE ? 'icon_m42kiosk_mobile' : "icon_m42kiosk_npatient_registration"}></i>
                                <div className='d-flex flex-column justify-content-center'>
                                    <span>{menu?.branchNameEn}</span>
                                    <span>{menu?.branchNameAr}</span>
                                </div>
                            </div>
                        </div>
                    }
                </div>
            ))}
        </div>
    )
}
export default React.memo(LoginMenus);